import { darken, lighten, createTheme as createMuiTheme } from "@mui/material";
import {
  solv3dPrimary,
  solv3dSecondary,
  mosaicPrimary,
  mosaicSecondary
} from "./colors";
import { Brand } from "../providers";

export const themeSpacing = 8;

export const createTheme = (brand: Brand) => {
  const isMosaic = brand === "mosaic";

  const primaryColor = isMosaic
    ? mosaicPrimary
    : solv3dPrimary;

  const secondaryColor = isMosaic
    ? mosaicSecondary
    : solv3dSecondary;

  return createMuiTheme({
    spacing: themeSpacing,
    components: {
      MuiPopover: {
        styleOverrides: {
          root: {
            "z-index": "1301 !important"
          }
        }
      },
      MuiTooltip: {
        defaultProps: {
          disableInteractive: true
        },
        styleOverrides: {
          tooltip: {
            backgroundColor: "rgba(0, 0, 0, 0.7)",
          },
          arrow: {
            "&::before": {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              border: "0px"
            }
          }
        }
      },
      MuiDialogTitle: {
        styleOverrides: {
          root: {
            padding: themeSpacing,
            fontSize: "1.0rem !important"
          },
        }
      },
      MuiDialogContent: {
        styleOverrides: {
          root: {
            padding: 2 * themeSpacing,
          }
        }
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            padding: themeSpacing
          }
        }
      },
      MuiSelect: {
        defaultProps: {
          size: "small",
          variant: "standard"
        }
      },
      MuiTextField: {
        defaultProps: {
          size: "small",
          variant: "standard"
        }
      },
      MuiTabs: {
        defaultProps: {
          indicatorColor: "secondary",
          textColor: "inherit"
        }
      },
      MuiSwitch: {
        defaultProps: {
          size: "small",
          color: "secondary"
        }
      },
      MuiCheckbox: {
        defaultProps: {
          size: "small",
          color: "secondary"
        }
      },
      MuiRadio: {
        defaultProps: {
          size: "small",
          color: "secondary"
        }
      }
    },
    palette: {
      primary: {
        main: primaryColor,
        light: lighten(primaryColor, 0.25),
        dark: darken(primaryColor, 0.25)
      },
      secondary: {
        main: secondaryColor,
        light: lighten(secondaryColor, 0.25),
        dark: darken(secondaryColor, 0.25)
      },
      mode: "light"
    },
    mixins: {
      toolbar: {
        // override default
      }
    }
  });
};
